import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"
import { AlertDescription } from "@/components/ui/alert-description"
import { AlertTitle } from "@/components/ui/alert-title"

const alertVariants = cva(
  "relative w-full rounded-lg border px-4 py-3 text-sm [&>svg+div]:translate-y-[-3px] [&>svg]:absolute [&>svg]:left-4 [&>svg]:top-4 [&>svg]:text-foreground [&>svg~*]:pl-7",
  {
    variants: {
      variant: {
        default: "bg-background text-foreground",
        destructive:
          "border-destructive/50 text-destructive dark:border-destructive [&>svg]:text-destructive",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

const Alert = ({ className, variant, ref, ...props }) => (
  <div
    ref={ref}
    role="alert"
    className={cn(alertVariants({ variant }), className)}
    {...props} />
)
Alert.displayName = "Alert"

export { Alert, AlertTitle, AlertDescription }
